import { Injectable, computed, signal } from '@angular/core';

const STORAGE_KEY = 'oms.widget.hiddenWidgets';

@Injectable({ providedIn: 'root' })
export class HomeWidgetVisibilityStore {
    private readonly _hiddenWidgets = signal<string[]>(this._loadHiddenWidgets());

    public readonly hiddenWidgets = computed(() => this._hiddenWidgets());

    public isVisible(widgetId: string): boolean {
        return !this._hiddenWidgets().includes(widgetId);
    }

    public setVisible(widgetId: string, visible: boolean): void {
        const current = this._hiddenWidgets();
        const next = visible
            ? current.filter(id => id !== widgetId)
            : Array.from(new Set([...current, widgetId]));

        this._hiddenWidgets.set(next);
        this._saveHiddenWidgets(next);
    }

    public reset(): void {
        this._hiddenWidgets.set([]);
        this._saveHiddenWidgets([]);
    }

    private _loadHiddenWidgets(): string[] {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) {
                return [];
            }

            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) {
                return [];
            }

            return parsed.filter((item): item is string => typeof item === 'string' && item.length > 0);
        } catch {
            return [];
        }
    }

    private _saveHiddenWidgets(hiddenWidgets: string[]): void {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(hiddenWidgets));
        } catch {

        }
    }
}
